
document.addEventListener('click', function (event) {
  const button = event.target.closest(
    '.jl-quantity-minus, .jl-quantity-plus'
  );

  if (!button) return;

  const wrapper = button.closest('.jl-quantity-selector');
  if (!wrapper) return;

 const input = wrapper.querySelector('input[name="quantity"], input[name="updates[]"]');
  if (!input || input.disabled) return;

  const current = parseInt(input.value, 10) || 1;
  const min = Math.max(1, parseInt(input.min, 10) || 1);
  const max = input.max ? parseInt(input.max, 10) : Infinity;

  const change = button.classList.contains('jl-quantity-plus') ? 1 : -1;
  const next = Math.min(max, Math.max(min, current + change));

  if (next === current) return;

  input.value = next;
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});